var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.filteredGenerations},on:{"change":_vm.onChange,"input":function($event){return _vm.$emit('input', $event)}}},'v-autocomplete',this.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }